import { render, staticRenderFns } from "./Cookies.vue?vue&type=template&id=73acad78&scoped=true&"
import script from "./Cookies.vue?vue&type=script&lang=ts&"
export * from "./Cookies.vue?vue&type=script&lang=ts&"
import style0 from "./Cookies.vue?vue&type=style&index=0&id=73acad78&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73acad78",
  null
  
)

export default component.exports